import { Box, Grid, LinearProgress } from "@mui/material";
import NotFoundFullScreenMessage from "../../../components/fullScreenMessage/NotFoundFullScreenMessage";
import PageContentWrapper from "../../../components/wrappers/PageContentWrapper";
import usePendingAppointments from "../../../hooks/usePendingAppointments";
import { useIsMobile } from "../../../utils/Functions";
import Resting from "./components/fullScreenMessage/Resting";
import Paging from "./components/Paging";
import PendingAppointment from "./components/PendingAppointment";
import PendingAppointmentsFilter from "./components/PendingAppointmentsFilter";

export default function PendingAppointmentsPage() {
  const isMobile = useIsMobile();
  const { data, isLoading: loading, error } = usePendingAppointments();
  const appointments = data?.appointments;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <PageContentWrapper marginTop={9}>
        <PendingAppointmentsFilter pages={data?.pages} />
        <Content isLoading={loading} error={error} data={appointments} />
      </PageContentWrapper>

      {isMobile ? (
        <Box sx={{ mt: "auto" }}>
          <Paging pages={data?.pages} />
        </Box>
      ) : null}
    </Box>
  );
}

function Content({ isLoading, error, data }) {
  if (isLoading) {
    return <LinearProgress />;
  } else if (error) {
    return <NotFoundFullScreenMessage />;
  }

  const renderCondition = data?.length < 1 && !isLoading && !error;

  if (renderCondition) {
    return <Resting />;
  }
  return (
    <Grid container spacing={1} sx={{ flexGrow: 1 }}>
      {data?.map((item) => (
        <PendingAppointment key={item.id} appointment={item} />
      ))}
    </Grid>
  );
}
